export const headerMobile = 116
export const headerMobileHideScroll = 60
export const headerDesktop = 76
